
export const floorPlans = {
  id: "2288",
  name: "Floor Plans",
  url: "/floor-plans",
  parent_id: "2287"
};
export const mapsAndFloorPlans = {
  id: "2287",
  name: "Maps and Floor plans",
  url: "/maps-and-floor-plans",
  parent_id: ""
};
export const hotelPlans = {
  id: "2191",
  name: "Hotel Plans",
  url: "/hotel-plans",
  parent_id: "2287"
};
export const locationPlans = {
  id: "2192",
  name: "Location plans",
  url: "/location-plans",
  parent_id: "2287"
};

export const factsheets = {
  id: "2205",
  name: "Factsheets",
  url: "/factsheets",
  parent_id: "hotel"
};

export const hotelFactsheets = {
  id: "2206",
  name: "Hotel factsheets",
  url: "/hotel-factsheets",
  parent_id: "2205"
};
export const mealPlanFactsheets = {
  id: "2207",
  name: "Meal Plan factsheets",
  url: "/meal-plan-factsheets",
  parent_id: "2205"
};
export const thematicalFactsheets = {
  id: "2208",
  name: "Thematical factsheets",
  url: "/thematical-factsheets",
  parent_id: "2205"
};
export const WeddingFactsheets = {
  id: "2240",
  name: "Wedding factsheets",
  url: "/wedding-factsheets",
  parent_id: "2205"
};

export const newFactsheets = {
  id: "2206",
  name: "New Factsheets",
  url: "/new-factsheets",
  parent_id: "2206",
  counter: 6,
};
export const cartItem = {
    id: "cart-items",
    name: "Items In Your Cart",
    url: "/cart",
    parent_id: "",
    counter: true,
  };

  export const cartsize = {
    id: "cart-size",
    name: "TOTAL FILE SIZE",
    url: "/cart",
    parent_id: "",
    counter: true,
  };

  export const quickInfo = {
  id: "quick-info",
  name: "Quick info",
  url: "/quick-info",
  parent_id: "hotel"
};
export const brochure = {
  id: "2209",
  name: "Brochures",
  url: "/brochures",
   parent_id: "hotel"
};

export const hotelBrochure = {
  id: "2210",
  name: "Hotel brochures",
  url: "/hotel-brochures",
   parent_id: "2209"
};
export const brochureSpa = {
  id: "2211",
  name: "Spa brochures",
  url: "/brochure-spa",
   parent_id: "2209"
};
export const GolfBrochure = {
  id: "2213",
  name: "Golf brochures",
  url: "/golf-brochures",
   parent_id: "2209"
};
export const WeddingBrochures = {
  id: "2212",
  name: "Wedding brochures",
  url: "/Wedding-brochures",
   parent_id: "2209"
};
export const brochuresB2B = {
  id: "2219",
  name: "B2B brochures",
  url: "/brochures-B2B",
  parent_id: "2209"
};
export const divingBrochures = {
  id: "2214",
  name: "Diving brochures",
  url: "/diving-brochures",
  parent_id: "2209"
};
export const newBrochure = {
    id: "2209",
    name: "New Brochure",
    url: "/new-brochure",
    counter: 7,
    parent_id: "2209"
  };

  export const programs = {
    id: "2243",
    name: "Programs",
    url: "/programs",
    parent_id: "2215"
  };

  export const roomCapacitieslocation = {
    id: '2292',
    name: "Room capacities & location",
    url: "/room-capacities-location",
    parent_id: ""
  };

  export const ecoResponsibleDocument = {
    id: 'eco-responsible-document',
    name: "Eco-responsible document",
    url: "/eco-responsible-document",
    parent_id: ""
  };

  export const menus = {
    id: "2244",
    name: "Menus",
    url: "/menus",
    parent_id: "2215"
  };

  export const roomStatus = {
  id: "room-status",
  name: "Room Status",
  url: "/room-status",
  parent_id: "hotel"
};
export const newRoomStatus = {
  id: "new-room-status",
  name: "New Room Status",
  url: "/new-room-status",
  counter: 3,
  parent_id: ""
};
export const miniTeens = {
  id: "mini",
  name: "Mini/Teens Club Program",
  url: "/mini-teens-club-program",
   parent_id: "hotel"
};
export const programPrime = {
  id: "2215",
  name: "Prime program",
  url: "/programme-prime",
  parent_id: "hotel"
};
export const ficheAi = {
  id: "fiche-ai",
  name: "Fiche AI",
  url: "/fiche-ai",
  parent_id: ""
};

export const lUpdate = {
  id: "2233",
  name: "L'Update",
  url: "/l-update",
  parent_id: "2220"
};

export const newsletterB2B = {
  id: "newsletter-b2b",
  name: "Newsletter B2B",
  url: "/newsletter-b2b",
  parent_id: ""
};

export const blog = {
  id: "blog",
  name: "Blog",
  url: "/blog",
  parent_id: ""
};

export const pictures = {
  id: "pictures",
  name: "Pictures & Videos",
  url: "/pictures",
  parent_id: ""
};
export const videos = {
  id: "videos",
  name: "Videos",
  url: "/videos",
  parent_id: ""
};

export const weddingCalendar = {
  id: "wedding-calendar",
  name: "Wedding calendar",
  url: "/wedding-calendar",
  parent_id: ""
};

export const gIRates = {
  id: "2228",
  name: "G & I rates",
  url: "/gi-rates",
  parent_id: "2227"
};
export const gIFactsheets = {
  id: "2229",
  name: "G & I factsheets",
  url: "/gi-factsheets",
  parent_id: "2227"
};

export const logo = {
  id: "2231", 
  name: "Logos",
  url: "/logo",
  parent_id: "2230"
};

export const graphicChart = {
  id: "2232",
  name: "Graphic charts",
  url: "/graphic-chart",
  parent_id: "2230"
};
export const myAccount = {
  id: "my-account",
  name: "My account",
  url: "/my-account",
  parent_id: ""
};
export const changePassword = {
  id: "change-password",
  name: "Change password",
  url: "/change-password",
  parent_id: ""
};

export const manageUsers = {
  id: "manage-users",
  name: "Users",
  url: "/users",
  parent_id: ""
};
export const logout = {
  id: "logout",
  name: "Logout",
  url: "/logout",
  parent_id: ""
};

export const mauritius = {
  id: "mauritius",
  name: "Mauritius",
  url: "/mauritius",
  parent_id: ""
}

export const beachcomberExp = {
  id: "2218",
  name: "Beachcomber Experiences",
  url: "/beachcomber-experiences",
  parent_id: "2205"
}

export const primeProgram = {
  id: "2215",
  name: "Prime program",
  url: "/prime-program",
  parent_id: ""
}

export const B2B_brochure = {
  id: "2219",
  name: "B2B brochure",
  url: "/B2B-brochures",
  parent_id: "2209"
}

export const spaMenu  = {
  id: "2224",
  name: "Spa menu",
  url: "/spa-menu",
  parent_id: "2244"
}
export const restaurantsMenus  = {
  id: "2225",
  name: "Restaurants menus",
  url: "/restaurants-menus",
  parent_id: "2244"
}
export const barMenus  = {
  id: "2226",
  name: "Bar menus",
  url: "/bar-menus",
  parent_id: "2244"
}

export const logoPartners = {
  id: "2286",
  name: "Logo partners",
  url: "/logo-partners",
  parent_id: "2230"
}

export const monthlyStatistics = {
  id: "2284",
  name: "Monthly statistics",
  url: "/monthly-statistics",
  parent_id: "2282"
}

export const forwardBookings = {
  id: "2283",
  name: "Forward bookings",
  url: "/forward-bookings",
  parent_id: "2282"
}
export const aLaCarteECatalogue = {
  id: "2242",
  name: "A la Carte e-catalogue",
  url: "/a-la-carte-e-catalogue",
  parent_id: "2209"
}

export const roomStatusRoute = "/room-status";

export const submenuItems = [
  quickInfo,
  factsheets,
  // hotelPlans,
  brochure,
  roomStatus,
  // miniTeens,
  programPrime,
  logo
  // ficheAi,
];

export const toolboxSubItem = [

]

export const menuItems = [
  {
    name: "Destination",
    id: "destination",
    type: "simple-menu",
    icon: "bi bi-pin-map",
    children:[
      {...mauritius},
     
    ]
  },
  {
    name: "Hotels",
    id: "hotels",
    type: "accordion-menu",
    icon: "bi bi-star",
   
    children: [
      {
        name: "Royal Palm Beachcomber Luxury",
        id: "royal-palm",
        category: "Luxury",
        moto: "A legend, a reverie",
        children: submenuItems,
      },
      {
        name: "Dinarobin Beachcomber",
        id: "dinarobin",
        category: "Golf Resort & Spa",
        moto: "A symbol of Tropical Elegance",
        children: submenuItems,
      },
      {
        name: "Paradis Beachcomber",
        id: "paradis",
        category: "Golf Resort & Spa",
        moto: "The favourite destination for families",
        children: submenuItems,
      },
      {
        name: "Trou Aux Biches Beachcomber",
        id: "trou-aux-biches",
        category: "Golf Resort & Spa",
        moto: "The place for pleasure seekers",
        children: submenuItems,
      },
      {
        name: "Shandrani Beachcomber",
        id: "shandrani",
        category: "Resort & Spa",
        moto: "Stars in your eyes", 
        children: submenuItems,
      },
      {
        name: "Victoria Beachcomber",
        id: "victoria",
        category: "Resort & Spa",
        moto: "A friendly and relaxed port of call",
        children: submenuItems,
      },
      {
        name: "Canonier Beachcomber",
        id: "canonier",
        category: "Resort & Spa",
        moto: "The charm and authenticity of a historical site",
        children: submenuItems,
      },
      {
        name: "Maurica Beachcomber",
        id: "maurica",
        category: "Resort & Spa",
        moto: "A lively holiday",
        children: submenuItems, 
      },
    ],
  },
  {
    name: "Toolbox",
    id: "toolbox",
    type: "simple-menu",
    icon: "bi bi-briefcase",
    children: [factsheets, brochureSpa, floorPlans,beachcomberExp],
  },
  {
    name: "News",
    id: "news",
    type: "simple-menu",
    icon: "bi bi-chat",
    children: [lUpdate, newsletterB2B, blog],
  },
  {
    name: "Pictures & Videos",
    id: "pictures_videos",
    type: "simple-menu",
    icon: "pi pi-image ",
    children: [pictures],
  },
  {
    name: "Wedding",
    id: "wedding",
    type: "simple-menu",
    icon: "bi bi-slash-circle",
    children: [factsheets, brochureSpa, weddingCalendar, pictures],
  },
  {
    name: "MICE",
    id: "mice",
    type: "simple-menu",
    icon: "bi bi-people",
    children: [gIRates, gIFactsheets, pictures, videos],
  },
  {
    name: "Room status",
    id: "room_status",
    type: "simple-menu",
    icon: "bi bi-grid-3x3",
    children: [
      {
        name: "Royal Palm Beachcomber Luxury",
        id: "royal-palm",
        url: roomStatusRoute,
      },
      {
        name: "Dinarobin Beachcomber",
        id: "dinarobin",
        url: roomStatusRoute,
      },
      {
        name: "Paradis Beachcomber",
        id: "paradis",
        url: roomStatusRoute,
      },
      {
        name: "Trou Aux Biches Beachcomber",
        id: "trou-aux-biches",
        url: roomStatusRoute,
      },
      {
        name: "Shandrani Beachcomber",
        id: "shandrani",
        url: roomStatusRoute,
      },
      {
        name: "Victoria Beachcomber",
        id: "victoria",
        url: roomStatusRoute,
      },
      {
        name: "Canonier Beachcomber",
        id: "canonier",
        url: roomStatusRoute,
      },
      {
        name: "Maurica Beachcomber",
        id: "maurica",
        url: roomStatusRoute,
      },
    ],
  },
  {
    name: "Logos & Graphic charts",
    id: "2180",
    type: "simple-menu",
    icon: "bi bi-graph-up-arrow ",
    children: [logo, graphicChart],
  },

  {
    name: "Settings",
    id: "settings",
    type: "simple-menu",
    icon: "bi bi-gear",
    children: [myAccount, changePassword, manageUsers, logout],
  },
];

export const notificationMenu = {
    name: "Notifications",
    id: "notification",
    type: "simple-menu",  
    icon: "",
  children: [],
};

export const cartMenu = {
    name: "Summary",
    id: "cart",
    type: "simple-menu",
    icon: "",
    url: "/cart",
  children: [cartItem, cartsize],
};



export const userTitles=["Mr","Mrs","Miss"];



export const daysOfWeek = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "satuday",
  "sunday", 
];

export const languages = ['en','fr'];

export const factsheet_sub_cat =[2206,2207,2240]; // this is all sub category item of factsheet retrieve from drupal api call
export const brochure_sub_cat =[2210,2212,2213,2214,2219 ]; // this is all sub category item of brochure retrieve from drupal api call

export const documentRoutes = [
  "/factsheets/:id",
  "/hotel-factsheets/",
  "/meal-plan-factsheets/",
  "/thematical-factsheets/",
  "/wedding-factsheets/",
  "/gi-factsheets",
  "/floor-plans/*",
  "/maps-and-floor-plans/*",
  "/hotel-plans/*",
  "/location-plans/*",
  "/brochures/:id",
  "/brochure-spa/*",
  "/hotel-brochures/*",
  "/golf-brochures/*",
  "/Wedding-brochures/*",
  "/diving-brochures/*",
  "/mini-teens-club-program/*",
  "/programme-prime/*",
  "/fiche-ai",
  "/eco-responsible-document",
  "/room-capacities-location",
  "/programs",
  "/menus",
  "/logo",
  "/logo/:id",
  "/graphic-chart",
  "/gi-rates",
  "/beachcomber-experiences",
  "/prime-program",
  "/B2B-brochures",
  "/spa-menu",
  "/restaurants-menus",
  "/bar-menus",
  "/logo-partners",
  "/monthly-statistics",
  "/forward-bookings",
  "/a-la-carte-e-catalogue",
];
export const existInCart = "This document is already in your cart."

/* The above code is exporting an array named `toAddFilter` containing a list of categories IDS. */
export const toAddFilter = [
  2206,
  2231,
  2207,
  2210,
  2211,
  2244,
  2232,
  2224,
  2225,
  2226,
  2215,
  2288
];

export const term_and_condition = "All content provided by Beachcomber Resorts & Hotels remains the exclusive property of our organization. Unauthorized modification and reproduction, or distribution of the Content are prohibited. Users must always credit Beachcomber Resorts & Hotels when utilizing our Content. For any other uses or inquiries, please contact us directly to obtain permission. For further assistance or to address any questions, please reach out to us at adminb2b@beachcomber.com. We may update these terms at any time, and continued use of the Content implies acceptance of any changes."